import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import Button from 'components/Buttons/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  flex: 1;
`;

export const Content = styled.div`
  margin-bottom: 80px;
`;

export const ButtonContainer = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    position: sticky;
    bottom: 0;
    margin-top: auto;
  }

  @media ${({ theme }) => theme.device.mobile} {
    width: 100%;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.usersList.cardBackground};
    left: 0;
    bottom: 0;
    right: 0;
    position: fixed;
  }
`;

export const StyledButton = styled(Button)`
  height: auto;
  min-height: 55px;
  font-size: 16px;
  line-height: initial;
  padding: 14px;

  @media ${({ theme }) => theme.device.mobile} {
    margin: 0px 16px 32px 16px;
  }
`;

export const List = styled.ol`
  display: flex;

  @media ${({ theme }) => theme.device.mobile} {
    flex-direction: column;
    align-items: center;
  }

  @media ${({ theme }) => theme.device.desktop} {
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
  }
`;

export const SubTitle = styled.span`
  font-size: 12px;
  color: ${({ theme }) => theme.usersList.dataColor};
  text-align: center;
  font-weight: normal;
`;

export const BoxContainer = styled.div`
  display: flex;
  height: 80px;
  align-items: center;
  padding: 0 24px;
  width: 100%;
  border: 1px ${({ theme }) => theme.rule.ruleList.lightGrey};
  border-style: solid none;
  background-color: ${({ theme }) => theme.rule.ruleList.white};

  @media ${({ theme }) => theme.device.desktop} {
    margin-bottom: 16px;
    border: none;
  }
`;

export const ButtonGhost = styled.button`
  display: flex;
  background-color: ${({ theme }) => theme.primaryBackgroundColor};
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.primaryBackgroundColor};
  cursor: pointer;
`;

export const ButtonGhostIcon = styled.img`
  margin-right: 8px;
`;

export const LoadingContainer = styled.div`
  display: flex;
  margin: auto;

  @media ${({ theme }) => theme.device.desktop} {
    height: 100%;
  }
`;

export const HeaderEdit = styled.button`
  font-weight: 600;
  text-align: right;
  color: ${({ theme }) => theme.primaryBackgroundColor};
  cursor: pointer;
  background: ${ColorPalette.Transparent};

  @media ${({ theme }) => theme.device.mobile} {
    position: absolute;
    right: 24px;
    top: 28px;
  }
`;

export const TextModal = styled.span`
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: ${({ theme }) => theme.travelApproval.modal.modalTextColor};

  & > strong {
    font-weight: 600;
  }
`;

export const AlertMessageContainer: any = styled.div`
  border-radius: 16px;
  box-shadow: 0 6px 10px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  color: ${ColorPalette.HEX.CharlestonGreen};
  margin-top: 15px;
  margin-bottom: 32px;
  background: ${ColorPalette.HEX.White};

  & img {
    margin-right: 16px;
  }

  & span {
    font-weight: 500;
    padding: 10px;
  }

  & strong {
    color: ${({ theme }) => theme.primaryBackgroundColor};
    font-weight: 600;
  }
`;
